import {
  UPDATE_USER_STEP,
  SET_NEIGHBOURHOODS,
  SET_NEIGHBOURHOOD,
  SET_RECOMMENDED_NEIGHBOURHOODS,
  RESET_RECOMMENDED_NEIGHBOURHOODS,
  SET_TRAVEL_MODE,
  SET_NEIGHBOURHOOD_HOVER_NAME,
  SET_SEARCH_BOX_RESULT,
  SET_COMMUTE,
  TOGGLE_MAP,
  SET_COLOURS
} from '../../actions/Map/navActions.js';
// import {getNeighbourhoods} from "../../actions/Map/dataActions.js";

const initialState = {
  user_step: "work",
  travel_mode: "DRIVING",
  neighbourhood_hover_name: undefined,
  commute: undefined,
  selected_neighbourhood: undefined,
  selected_neighbourhood_name: undefined,
  selected_neighbourhood_desc: undefined,
  selected_neighbourhood_url: undefined,
  polygon_coordinates: undefined,
  polygon_center: undefined,
  recommended_neighbourhoods: undefined,
  display_map: true,
  neighbourhoods: [],
  colours: []
};


export function navReducer(state=initialState, action) {
  var coordinates = undefined;
  var center = undefined;
  var name = undefined;
  var desc = undefined;
  var url = undefined;

  switch(action.type) {
    case SET_NEIGHBOURHOODS:
      return {...state, neighbourhoods: action.payload}
    case SET_COLOURS:
      return {...state, colours: action.payload.colours}
    case SET_COMMUTE:
      return { ...state, commute: action.payload }

    case TOGGLE_MAP:
      return {...state, display_map: action.payload}

    case UPDATE_USER_STEP:
      return { ...state, user_step: action.payload }

    case SET_TRAVEL_MODE:
    return { ...state, travel_mode: action.payload }

    case SET_NEIGHBOURHOOD_HOVER_NAME:
    return { ...state, neighbourhood_hover_name: action.payload }

    case SET_SEARCH_BOX_RESULT:
    return { ...state, search_box_result: action.payload }

    case SET_NEIGHBOURHOOD:
    if (action.payload === undefined){
      return {
        ...state,
        selected_neighbourhood: undefined,
        selected_neighbourhood_name: undefined,
        neighbourhood_hover_name: undefined,
        selected_neighbourhood_desc: undefined,
        selected_neighbourhood_url: undefined,
        polygon_coordinates: undefined,
        polygon_center: undefined
      }
    } else {
      for (let i = 0; i < state.neighbourhoods.length; i++){
        let hood = state.neighbourhoods[i];
        if (parseFloat(hood.fields.neighbourhood_id) === parseFloat(action.payload)) {
          coordinates = hood.fields.geo_shape.coordinates;
          center = hood.geometry.coordinates;
          name = hood.fields.name;
          desc = hood.fields.desc;
          url = hood.fields.realtor_url;
          break;
        }
      }
      return {
        ...state,
        selected_neighbourhood: action.payload,
        selected_neighbourhood_name: name,
        selected_neighbourhood_desc: desc,
        selected_neighbourhood_url: url,
        polygon_coordinates: coordinates,
        polygon_center: center
      }
    }

    case RESET_RECOMMENDED_NEIGHBOURHOODS:
      return {
        ...state,
        recommended_neighbourhoods: undefined,
      }


    case SET_RECOMMENDED_NEIGHBOURHOODS:
      const neighbourhoods = action.payload;
      const recommendation = [
        neighbourhoods.results[0].neighbourhoods[0].neighbourhood,
        neighbourhoods.results[0].neighbourhoods[1].neighbourhood,
        neighbourhoods.results[0].neighbourhoods[2].neighbourhood,
        neighbourhoods.results[0].neighbourhoods[3].neighbourhood,
        neighbourhoods.results[0].neighbourhoods[4].neighbourhood
      ];
      const id = neighbourhoods.results[0].neighbourhoods[0].neighbourhood.id;
      for (let i = 0; i < state.neighbourhoods.length; i++){
        let hood = state.neighbourhoods[i];
        if (parseFloat(hood.fields.neighbourhood_id) === parseFloat(id)) {
          coordinates = hood.fields.geo_shape.coordinates;
          center = hood.geometry.coordinates;
          name = hood.fields.name;
          desc = hood.fields.desc;
        }
      }
      return {
        ...state,
        selected_neighbourhood: id,
        selected_neighbourhood_name: name,
        selected_neighbourhood_desc: desc,
        polygon_coordinates: coordinates,
        polygon_center: center,
        recommended_neighbourhoods: recommendation
      }


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/Map/navReducer.js